import React, { useMemo } from "react";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import CustomBtn from "components/fragments/CustomBtn";
import { getCurrentDateTime } from "utils/getCurrentDateTime";
import { useSelector } from 'react-redux';

export default function PosStartupConfirmationModal({ modalOpenObj, selectedDevice, sessionStartData, userProfile, businessName = "", branchName = "", onConfirm }) {
  const loading = useSelector(state => state.common.loading);

  const totalCashAmount = useMemo(() => {
    if (!sessionStartData) return 0;

    const cashValues = {
      cash_1000: { value: sessionStartData.cash_1000 || 0, multiplier: 1000 },
      cash_500: { value: sessionStartData.cash_500 || 0, multiplier: 500 },
      cash_100: { value: sessionStartData.cash_100 || 0, multiplier: 100 },
      cash_50: { value: sessionStartData.cash_50 || 0, multiplier: 50 },
      cash_20: { value: sessionStartData.cash_20 || 0, multiplier: 20 },
      cash_10: { value: sessionStartData.cash_10 || 0, multiplier: 10 },
      cash_5: { value: sessionStartData.cash_5 || 0, multiplier: 5 },
      cash_1: { value: sessionStartData.cash_1 || 0, multiplier: 1 },
    };

    return Object.values(cashValues).reduce((total, { value, multiplier }) => {
      return total + value * multiplier;
    }, 0);
  }, [sessionStartData]);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("th-TH", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  const getStaffName = () => {
    if (!userProfile) return "ไม่ระบุ";
    return `${userProfile.first_name || ""} ${userProfile.last_name || ""}`;
  };

  const getPosName = () => {
    if (!selectedDevice) return "POS";
    return selectedDevice.posInfo?.posName || "POS";
  };

  const handleCancel = () => {
    modalOpenObj.setModalOpen(false);
  };

  const handleConfirm = async () => {
    if (onConfirm && sessionStartData) {
      await onConfirm(sessionStartData);
    }
  };

  const InfoRow = ({ label, value }) => (
    <div className="flex justify-between gap-[min(0.98vw,10px)]">
      <div className="whitespace-nowrap text-[var(--color-grey-2)]">{label}</div>
      <div className="truncate">{value}</div>
    </div>
  );

  return (
    <Modal
      aria-labelledby="pos-startup-confirmation-modal"
      aria-describedby="modal-to-confirm-pos-startup-with-cash-float"
      open={modalOpenObj.modalOpen}
      onClose={handleCancel}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { timeout: 500 } }}
    >
      <Fade in={modalOpenObj.modalOpen && !loading}>
        <div className="bg-white w-[min(37.11vw,380px)] p-[min(2.44vw,25px)] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-[min(1.46vw,15px)] text-16 text-[var(--color-black-2)]">
          <div className="text-18 font-[700] leading-[2.2]">คุณต้องการยืนยันการเข้าใช้งาน</div>

          <div className="mt-[min(1.46vw,15px)] flex flex-col gap-[min(1.17vw,12px)]">
            <InfoRow label="ชื่อธุรกิจ :" value={businessName} />
            <InfoRow label="ชื่อสาขา :" value={branchName} />
            <InfoRow label="พนักงาน :" value={getStaffName()} />
            <InfoRow label="วันที่/เวลา :" value={getCurrentDateTime()} />
            <InfoRow label="POS :" value={getPosName()} />
            <InfoRow label="ยอดเงินสดตั้งต้น :" value={formatCurrency(totalCashAmount)} />
          </div>

          <div className="bg-[#EDEDED] w-full h-[min(0.10vw,1px)] mt-[min(1.46vw,15px)] mb-[min(2.44vw,25px)] leading-[1]"></div>

          <div className="flex justify-center gap-[min(2.01vw,20.63px)]">
            <CustomBtn
              onClick={handleCancel}
              className="leading-[0.8] w-fit min-w-[min(10.25vw,105px)] text-18 text-[#6D788D] font-[600] min-h-[min(3.91vw,40px)] rounded-[min(0.78vw,8px)] btn-second-2-active"
              btntxt="ยกเลิก"
            />
            <CustomBtn
              onClick={handleConfirm}
              className="leading-[0.8] w-fit min-w-[min(10.25vw,105px)] text-18 text-white font-[600] min-h-[min(3.91vw,40px)] rounded-[min(0.78vw,8px)] btn-main-active"
              btntxt="ยืนยัน"
            />
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
